var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { closeSnackbar, SnackbarProvider } from "notistack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { CheckOutPage } from "./modules/HPP/checkout-page";
import "./i18n";
var wnd = window;
wnd.renderHpp = function (id, paymentSessionId, environment, bypassLuhnValidation) {
    var container = document.getElementById(id);
    var options = { sessionId: paymentSessionId, environment: environment, bypassLuhnValidation: bypassLuhnValidation };
    if (container) {
        var root = createRoot(container);
        root.render(_jsx(React.Fragment, { children: _jsx(SnackbarProvider, __assign({ maxSnack: 3, action: function (snackbarId) { return (_jsx(IconButton, __assign({ onClick: function () { return closeSnackbar(snackbarId); } }, { children: _jsx(CloseIcon, {}) }))); } }, { children: _jsx(CheckOutPage, { options: options }) })) }));
    }
};
